// import Main from '../Main';
// import '../../assets/css/dashboard.scss';
// import Download from '../MainSection/Download/Download';
// import { useNavigate, useParams } from 'react-router-dom';
// import DashboardConfig from '../PowerBi/DashboardConfig';

// function DemandDashboard() {
//     const { dashboardId } = useParams(); // Get the dashboard ID from the URL params
//     const navigate = useNavigate();

//     // Adjust to find the dashboard based on the actual structure of DashboardConfig
//     const selectedDashboard =
//         Array.isArray(DashboardConfig)
//             ? DashboardConfig.find(dashboard => dashboard.id === dashboardId)
//             : Object.values(DashboardConfig).flat().find(dashboard => dashboard.id === dashboardId);

//     if (!selectedDashboard) {
//         return <div>Dashboard not found</div>; // Handle case when dashboard is not found
//     }

//     const { label, url } = selectedDashboard;

//     const handleDashboardLibraryClick = () => {
//         navigate('/dashboard-library');
//     };

//     const handleBack = () => {
//         navigate(-1);
//     };

//     return (
//         <div className="dashboard-container">
//             <Main>
//                 <div className="components-download-container">
//                     <Download
//                         moduleName={label}
//                         showBackButton={true}
//                         showDashboardLibraryButton={true}
//                         showSaveCustomViewButton={true}
//                         showAnalyticsButton={false}
//                         showDownloadDropdown={true}
//                         onClick={handleDashboardLibraryClick}
//                         onBackClick={handleBack}
//                     />
//                 </div>
//                 <div className="powerbi-container">
//                     <iframe
//                         width="100%"
//                         // height="100%"
//                         title="demand_dashboard"
//                         src={url}
//                         frameBorder="0"
//                         allowFullScreen={true}
//                     >
//                     </iframe>
//                 </div>
//             </Main>
//         </div>
//     );
// }

// export default DemandDashboard;





import Main from '../Main';
import '../../assets/css/dashboard.scss';
import Download from '../MainSection/Download/Download';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { loadSettingsDynamicDashboard } from '../../redux/action';

function DemandDashboard() {
    const { dashboardId } = useParams(); // Get the dashboard ID from the URL params
    const location = useLocation(); // Access state passed through navigation
    const viewType = location.state?.viewType || 'public'; // 'public' or 'secured'
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Fetch dashboards when component mounts
    useEffect(() => {
        dispatch(loadSettingsDynamicDashboard());
    }, [dispatch]);

    // Get dynamic dashboards from Redux store
    const { getDynamicDashboardData } = useSelector((state) => state.data);

    // Ensure data is available before searching
    if (!getDynamicDashboardData || getDynamicDashboardData.length === 0) {
        return <div id="dvLoading"></div>;
    }

    // Find the selected dashboard
    const selectedDashboard = getDynamicDashboardData.find(
        (dashboard) => dashboard.DashboardLibraryID.toString() === dashboardId
    );

    if (!selectedDashboard) {
        return <div className="error-message">Dashboard not found</div>;
    }

    const { DashboardLibraryName, PublicLink, SecuredLink } = selectedDashboard;

    // Determine which link to use based on viewType
    const dashboardSrc = viewType === 'secured' ? SecuredLink : PublicLink;

    return (
        <div className="dashboard-container">
            <Main>
                <div className="components-download-container">
                    <Download
                        moduleName={DashboardLibraryName}
                        // showBackButton={true}
                        showDashboardLibraryButton={true}
                        showSaveCustomViewButton={true}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onClick={() => navigate('/dashboard-library')}
                        // onBackClick={() => navigate(-1)}
                    />
                </div>
                <div className="powerbi-container">
                    <iframe
                        width="100%"
                        height="600px"
                        title="demand_dashboard"
                        src={dashboardSrc}
                        frameBorder="0"
                        allowFullScreen
                    />
                </div>
            </Main>
        </div>
    );
}

export default DemandDashboard;

